import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

// images
import Gift from "../images/gift.gif";
import Logo from "../images/logo.png";
import Icon from "../images/plug.png";

// components
import "antd/dist/antd.css";
import { Button, Row, Col, Affix, Divider, Avatar } from "antd";

import liff from "@line/liff";

function Verify() {
  let navigate = useNavigate();

  const { refcode } = useParams();
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [loading, setLoading] = useState(false);

  useEffect(() => {
    setRefCode();
    checkUserID();
  }, []);

  const setRefCode = () => {
    if(refcode !== undefined){
      localStorage.setItem("RefCode", JSON.stringify(refcode));
    }
  }

  const checkUserID = () => {

    liff
      .init({ liffId: "1661365918-xWKzggZp" })
      .then(async () => {
        if (liff.isLoggedIn()) {
          const data = await liff.getIDToken();

          var config = {
            method: "POST",
            url: "https://us-central1-bhh-healthexpo.cloudfunctions.net/app/api/getProfile",
            // url: "http://localhost:5001/bhh-healthexpo/us-central1/app/api/getProfile",

            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
              "Access-Control-Allow-Origin": "*",
            },
            data: { token: data },
          };

          try {
            let res = await axios(config);

            if (res.data.status === 500) {
              navigate("/");
            } else {
              if (res.data.user_id !== undefined) {
                // setUserId(res.data.user_id);
                // setLoading(false);
                navigate("/");
              } else {
                localStorage.removeItem("RefCode");
                localStorage.setItem("Profile", JSON.stringify(res.data));
                localStorage.setItem("SandConnect", 1);
                navigate("/");
              }
            }
          } catch (e) {
            console.log(e);
            liff.closeWindow();
          }
        } else {
          liff.login();
        }
      })
      .catch((err) => {
        console.log(err);
        liff.closeWindow();
      });
  };

  const Loading = () => {
    return (
      <div className="center">
        <img src={Gift} alt="" style={{ width: "20%" }} />
        <br /> <p>Loading...</p>
      </div>
    );
  };

  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col span={21} style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                        Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>

      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="center">
            <div style={{ width: "90%", margin: "auto" }}>
              <Avatar size={120} src={Logo} />
              <br />
              <br />
              <a
                href={`https://sandconnect.web.app/virtualconnect/2/${userId}`}
              >
                <Button
                  size="large"
                  style={{
                    borderRadius: "5px",
                    color: "white",
                    background: "#0061af",
                    border: 0,
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    width: "100%",
                  }}
                >
                  <img
                    src={Icon}
                    style={{ marginRight: "10px", width: "20px" }}
                  />
                  เชื่อมต่อข้อมูลด้วย SandConnect
                </Button>
              </a>
              <Divider />
              <NavLink to="/">
                <span style={{ color: "#0061af" }}>ข้ามไปก่อน</span>
              </NavLink>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Verify;
